var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"google-map-area section",attrs:{"id":"support"}},[_c('GmapMap',{attrs:{"center":{lat:43.123076, lng:5.949125},"zoom":15,"map-type-id":"terrain"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }